import React from "react";
import '../../styles/FooterStyles.css';


const SimpleFooter = () => {
  return (
    <div className="simple-footer">
      <p className="text-secondary m-0">
        Constructora Cantabria © 2024. Todos los derechos reservados.
      </p>
    </div>
  );
};

export default SimpleFooter;
